import React, { useEffect } from "react";
import { Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ResetPassword } from "./views/resetPassword/ResetPassword";
import { ResetPasswordSuccess } from "./views/ForgotPassword/ResetPasswordSuccess";
import { authConstants } from "../../../_redux/_constants";
import { authReducerInitiate } from "../../../_redux/_actions";
import Logo from "../../../styles/img/df-logo.png";

export const AdminPasswordResetWrapper = () => {
  const actionDispatch = useDispatch();

  useEffect(() => {
    actionDispatch(authReducerInitiate());
    actionDispatch({ type: authConstants.RESET_OTP_CONFIRM_STATE });
  }, []);
  const adminPasswordResetScreenType = useSelector(
    (state) => state.auth?.adminPasswordResetScreenType,
  );

  const adminPasswordResetScreen = () => {
    switch (adminPasswordResetScreenType) {
      case authConstants.ADMIN_PASSWORD_RESET_SCREEN:
        return <ResetPassword />;
      case authConstants.ADMIN_PASSWORD_SUCCESS_SCREEN:
        return <ResetPasswordSuccess />;
      default:
        return <ResetPassword />;
    }
  };

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      {adminPasswordResetScreen()}
    </>
  );
};
